import React, { useCallback, useState } from 'react';
import { NavbarContext, type NavbarSlots } from './NavbarContext';

export const NavbarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [leftSlot, setLeftSlot] = useState<React.ReactNode>(null);
  const [rightSlot, setRightSlot] = useState<React.ReactNode>(null);

  const setSlots = useCallback(({ leftSlot, rightSlot }: NavbarSlots) => {
    setLeftSlot(leftSlot ?? null);
    setRightSlot(rightSlot ?? null);
  }, []);

  const clearSlots = useCallback(() => {
    setLeftSlot(null);
    setRightSlot(null);
  }, []);

  return (
    <NavbarContext.Provider value={{ leftSlot, rightSlot, setSlots, clearSlots }}>
      {children}
    </NavbarContext.Provider>
  );
};
